import { useEffect, useState } from 'react';
import { SortableList } from '../components/SortableList';
import PageBaseLayout from '../layouts/PageBaseLayout';
import useBackdrop from '../hooks/useBackdrop';
import { getCampaigns, updateCampaignPriorities } from '../fetchFns';
import useSnackbar from '../hooks/useSnackbar';
import type { Campaign } from '../models/types';
import {
  Button,
  type AlertColor,
  type AlertPropsColorOverrides,
} from '@mui/material';
import type { OverridableStringUnion } from '@mui/types';

export function createRange<T>(
  length: number,
  initializer: (index: number) => T,
): T[] {
  return [...new Array(length)].map((_, index) => initializer(index));
}

function getMockItems() {
  return createRange(50, (index) => ({ id: index + 1 }));
}

export default function CampaignsPriority() {
  // const [items, setItems] = useState(getMockItems);
  const [items, setItems] = useState<Campaign[]>([]);
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();

  const handleChangeItems = (newItems: Campaign[]) => {
    const campaignsWithNewPriorities = newItems.map((campaign, index) => ({
      ...campaign,
      priority: index + 1,
    }));
    setItems(campaignsWithNewPriorities);
  };

  const getData = async () => {
    backdrop.handleBackdropOpen();

    try {
      const campaignsResponse = await getCampaigns();
      const mappedCampaigns = (
        campaignsResponse.data.map((el: any) => ({
          ...el,
          merchant_name: el.merchants.name,
        })) as Campaign[]
      ).sort((a, b) => a.priority - b.priority);

      setItems(mappedCampaigns);
    } catch (error) {
      snackbar.handleSnackbarOpen('Failed to fetch campaigns', 'error');
    }

    backdrop.handleBackdropClose();
  };

  const handleSaveCampaignOrder = async () => {
    backdrop.handleBackdropOpen();
    let message = 'Campaign order saved successfully.';
    let severity:
      | OverridableStringUnion<AlertColor, AlertPropsColorOverrides>
      | undefined = 'success';

    try {
      const itemsMapped = items.map((campaign) => ({
        ...campaign,
        campaign_id: campaign.id,
      }));

      const response = await updateCampaignPriorities(itemsMapped);
      console.log(items);
    } catch (error) {
      const errorCast = error as Error;
      console.error(errorCast.stack);
      message = errorCast.message;
      severity = 'error';
    }
    snackbar.handleSnackbarOpen(message, severity);
    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PageBaseLayout title="Campaigns Priority">
      <Button variant="contained" onClick={handleSaveCampaignOrder}>
        Save Campaign Order
      </Button>
      <SortableList
        items={items}
        onChange={handleChangeItems}
        renderItem={(item: Campaign) => (
          <SortableList.Item id={item.id}>
            <SortableList.DragHandle />
            Brand: {item.merchant_name}
            <br />
            Campaign: {item.name}
          </SortableList.Item>
        )}
      />
    </PageBaseLayout>
  );
}
